import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faLink } from '@fortawesome/pro-light-svg-icons'

import {
  Box, DashboardModuleListItem, StatusBadge, Text,
} from '@domain-group/suit-theme'

import useTrackingLink from '@hooks/useTrackingLink'

import type { TrackingLinkModel } from '@domain-group/realhub-backend-api-types'

type TrackingLinkProps = {
  trackingLink: TrackingLinkModel,
}

const TrackingLinkListItem = (props: TrackingLinkProps) => {
  const {
    trackingLink,
    trackingLink: { shortened_url, title, total_views },
  } = props

  const { callbacks: { createOrEditTrackingLink } } = useTrackingLink(trackingLink)

  return (
    <DashboardModuleListItem
      onClick={() => createOrEditTrackingLink()}
      secondaryText={(
        <Box alignItems="center">
          <FontAwesomeIcon icon={faLink} />

          <Text color="bodyFontLightColor" marginLeft="small">{shortened_url}</Text>
        </Box>
      )}
      title={title}
    >
      {/*
       // @ts-expect-error TS2339 */}
      <DashboardModuleListItem.TertiaryText textProps={{ textAlign: 'right' }}>
        <StatusBadge text={total_views === 1 ? '1 View' : `${total_views} Views`} />
        {/*
       // @ts-expect-error TS2339 */}
      </DashboardModuleListItem.TertiaryText>
    </DashboardModuleListItem>
  )
}

export default TrackingLinkListItem
